import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';

export const useStyles = makeStyles<Theme>()((theme) => ({
  usersWrapper: {
    '& > div + div': {
      marginTop: 4,
    },
    '& > div:first-of-type': {
      marginTop: 0,
    },
  },
  tabsContent: {
    margin: theme.spacing(0.5, 0),
  },
}));
